var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification !== null)?_c('div',[_c(_vm.notificationComponent,{tag:"component",attrs:{"notification":_vm.notification}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }